import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Team from './pages/Team';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import RecipeAdmin from './pages/admin/RecipeAdmin';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Soul Kitchen | Traiteur végétalien à Paris - Restauration Collective Bio</title>
        <meta name="description" content="Soul Kitchen, traiteur végétalien spécialisé en restauration collective de 50 à 500 personnes. Cuisine locale, bio et de saison à Paris et en Île-de-France. Demandez votre devis gratuit." />
        <meta name="keywords" content="traiteur végane, traiteur végétalien, restauration collective, cuisine bio, traiteur Paris, événements entreprise, buffet végétalien, traiteur éco-responsable, cuisine de saison, catering végane" />
        <meta property="og:title" content="Soul Kitchen | Traiteur végétalien à Paris" />
        <meta property="og:description" content="Traiteur végétalien spécialisé en restauration collective. Cuisine locale, bio et de saison pour vos événements." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.soulkitchenandco.fr/" />
      </Helmet>
      <BrowserRouter>
        <Routes>
          {/* Admin routes (no header/footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/recipes" element={<RecipeAdmin />} />
          
          {/* Public routes (with header/footer) */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/equipe" element={<Team />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
